
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M3.5 6V1.5h10V6m0 5v4.5h-10V11M2 8.5h1.5m2.25 0h1.5m2.5 0h1.5m2.25 0H15"}})])
          )
        }
      }
    